import { SCENE_INTERACTION } from "../../../constants/scene";
import { SOCKET_EVENTS } from "../../../socket/Socket";
import { tourID } from "../../../socket/SocketTour";
import { tourExists, tourGuests, tourHasStarted, findKeyByValue } from "../../../socket/socketHelper";
import { SCENE_EVENTS } from "../../MVC/Model";
import { states } from "../../WebRTC/constants";
import { WebRTCAdaptor } from "../../WebRTC/media-server-external/webrtc_adaptor";
import TourModeWindow from "../../engine/TourModeWindow";

export default class TourModeScreenWebsocket {
  constructor({ model, socket }) {

    this.connectPromise = null;
    this.connectResolve = null;
    this.connectReject = null;

    this.model = model;
    this.socket = socket;


    this.webRTCAdaptor = null;

    this.dominantSpeakerFinderId = null;
    this.checkSpeakingStreamIds = new Array();

    this.sdpConstraints = {
      OfferToReceiveAudio: false,
      OfferToReceiveVideo: false
    };

    this.mediaConstraints = {
      video: "screen",
      audio: true
    };

    this.pc_config = {
      'iceServers': [{
        'urls': 'stun:stun1.l.google.com:19302'
      }]
    };

    this.roomNameBox = tourID;

    this.roomOfStream = new Array();
    this.streamsList = new Array();

    this.publishStreamId = `${"TOUR-SCREEN-SHARE" + this.model.config.userId}`;
    this.isDataChannelOpen = false;
    this.isMicMuted = false;
    this.isCameraOff = false;
    this.roomTimerId = -1;
    this.onConnectCallback = null;
    this.localStream;
    this.initUsers = false;
    this.tourData = null;

    this.playOnly = false;

    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, (e) => {
      const { inputValue, componentValue, visibility, id } = e.data;
      this.roomNameBox = `${tourID}-${this.model.config.userId}`;
      if (id) {
        this.tourData = e.data;
      }
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, (e) => {
      this.tourData = this.model.tourData[e.data];
      this.roomNameBox = `${tourID}-${this.tourData.id}`;
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      const tourStarted = tourExists(tourID, this.model.tourData);
      if (!tourStarted) {
        return
      }
      this.leaveRoom();

    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_STOP, (e) => {
      this.tourData = {};
      this.leaveRoom();
      $("#leave-teour-screen-share").trigger("click");
      this.model.tourOnScreenShareSeatStandUp();
    });

    this.model.addEventListener(SCENE_INTERACTION.TOUR_TAKE_SEAT, async (e) => {
      if (this.webRTCAdaptor) {
        this.joinRoom();
        this.webRTCAdaptor.switchDesktopCapture(this.publishStreamId);
      }
      else {
        this.connect()
          .then(() => {
          })
          .catch((error) => {
            // Error occurred during initialization, handle the error
          });
      }
    });

    this.model.addEventListener(SCENE_INTERACTION.TOUR_MODE_USER_TAKES_SCREEN_SHARE_SEAT, (e) => {
      const { data: { meshId } } = e;
      this.socket.TOUR_userChangingScreenShareSeat(meshId, this.publishStreamId)
    });


    this.model.addEventListener(SCENE_INTERACTION.TOUR_MODE_USER_SCREEN_SHARE_SEAT_STAND_UP, (e) => {
      this.socket.TOUR_userStandUp();
      this.leaveRoom();
      var video = document.getElementById("myTourVideoScreenshare");
      if (video.srcObject) {
        var tracks = video.srcObject.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
        video.srcObject = null;
      }
    });
    this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED, (e) => {
      this.socket.TOUR_userStandUp();
      this.leaveRoom();
      var video = document.getElementById("myTourVideoScreenshare");
      if (video.srcObject) {
        var tracks = video.srcObject.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
        video.srcObject = null;
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.KILL_GUEST_MODE_SOCKET_REQUEST, async (e) => {
      this.publishing = false;
      this.webRTCAdaptor && this.webRTCAdaptor.stop(this.publishStreamId);
    });
    // this.connect()
  }


  connect = () => {
    if (this.connectPromise) {
      return this.connectPromise; // Return the existing Promise if it's already running
    }
    this.connectPromise = new Promise((resolve, reject) => {
      this.connectResolve = resolve;
      this.connectReject = reject;

      const self = this;
      // this.ignoredInfoTypes = ["ping", "pong", "roomInformation", "bitrateMeasurement"];
      this.webRTCAdaptor = new WebRTCAdaptor(
        {
          websocket_url: "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket",
          mediaConstraints: this.mediaConstraints,
          peerconnection_config: this.pc_config,
          sdp_constraints: this.sdpConstraints,
          localVideoId: "myTourVideoScreenshare",
          // isPlayMode: true,
          debug: false,
          // dataChannelEnabled: true,
          callback: (info, obj) => {

            this.handleCallback(info, obj);

            if (info == "closed") {
              //// console.log("Connection closed");
              if (typeof obj != "undefined") {
                console.log("Connecton closed: " + JSON.stringify(obj));
                reject(new Error("Connection closed"));
              } else if (info === "error") {
                reject(new Error(obj)); // Change to a more specific error message if available
              }
            }

          },
          callbackError: function (error, message) {
            if (error.indexOf("publishTimeoutError") != -1 && this.roomTimerId != null) {
              clearInterval(this.roomTimerId);
            }
            self.handleCallbackError(error, message)
          }
        });
    });
    return this.connectPromise;
  }

  handleCallback(info, obj) {
    if (info == "initialized") {
      this.joinRoom();
    }
    if (info == "leavedFromRoom") {
      // this.model.killStream($("#screenVideoANT")[0].srcObject);
      this.state = states.NOT_IN_ROOM;
      if (this.roomTimerId != null) {
        clearInterval(this.roomTimerId);
        clearInterval(this.dominantSpeakerFinderId);
        this.roomTimerId = null;
      }
    }
    if (info == "publish_started") {
      this.state = states.JOINED_ROOM;
      this.model.hideLoading()
      this.muteLocalMic();
      if (window.baglessTrack) {
        window.baglessTrack(this.model.config, "User started sharing their screen in tour mode", { data: { tourData: this.model.tourdata } })
      }
    }
    if (info == "publish_finished") {
      this.state = states.NOT_IN_ROOM;
    }
    if (info == "custom_publish") {
      this.model.showLoading();
      setTimeout(() => {
        this.publish();
      }, 1500)
    }
    if (info == "joinedTheRoom") {
      this.model.hideLoading()
      this.roomJoined = true;
      this.streamsList = obj.streams;
      this.model.publishStreamId = this.publishStreamId;
      const room = obj.ATTR_ROOM_NAME;
      this.roomOfStream[obj.streamId] = room;

      if (obj.streams != null) {
        obj.streams.forEach((item) => {
          console.log("Stream joined with ID: " + item);
          this.webRTCAdaptor.play(item, this.token, this.roomNameBox);
        });
      }
      // this.roomTimerId = setInterval(() => {
      //   this.webRTCAdaptor.getRoomInfo(this.roomNameBox, this.publishStreamId);
      // }, 5000);

      if (this.streamsList.length > 0) {
        this.dominantSpeakerFinderId = setInterval(() => {
          // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
        }, 200);
      }
      !this.connectPromise && (this.connectPromise());
      this.isResolved = true;
    }
    if (info == "roomInformation") {
      //Checks if any new stream has added, if yes, plays.
      for (let str of obj.streams) {
        if (!this.streamsList.includes(str)) {
          this.webRTCAdaptor.play(str, this.token,
            this.roomNameBox);
        }
      }
      // Checks if any stream has been removed, if yes, removes the view and stops webrtc connection.
      for (let str of this.streamsList) {
        if (!obj.streams.includes(str)) {
          this.removeRemoteVideo(str);
        }
      }
      //Lastly updates the current streamlist with the fetched one.
      this.streamsList = obj.streams;

      //Check video tracks active/inactive status
      this.checkVideoTrackStatus(this.streamsList);
    }
    else if (info == "newStreamAvailable") {
      console.log("new stream available with id: " + obj);
      if (!this.roomJoined) {
        return
      }
      this.playVideo(obj);
      if (this.dominantSpeakerFinderId == null) {
        this.dominantSpeakerFinderId = setInterval(() => {
          // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
        }, 200);
      }
    }
    else if (info == "play_started") {
      console.log(obj);
      // this.playVideo(obj);
      if (this.dominantSpeakerFinderId == null) {
        this.dominantSpeakerFinderId = setInterval(() => {
          // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
        }, 200);
      }
    }
    else if (info == "play_finished") {
      // console.log("play_finished");
      this.removeRemoteVideo(obj.streamId);
    }
    else if (info == "streamInformation") {
      this.streamInformation(obj);
    }
    else if (info == "browser_screen_share_supported") {
    }
    else if (info == "gotSoundList") {
      this.findDominantSpeaker(obj);
    }
    else if (info == "screen_share_stopped") {
      $("#leave-teour-screen-share").trigger("click");
      this.model.tourOnScreenShareSeatStandUp();
    }
  }

  handleCallbackError(error, message) {
    // Handle errors from the WebRTCAdaptor
    console.error("Callback Error:", error, message);
    this.errorCallback && this.errorCallback(error, message);
    if (error === "publishTimeoutError") {
      this.publish();
    }
    if (error === "ScreenSharePermissionDenied") {
      this.model.tourOnScreenShareSeatStandUp();
      this.model.alert('error', $trans('user-cancelled-share-text'));
    }
  }

  checkVideoTrackStatus = (streamsList) => {
    streamsList.forEach((item) => {
      if (item === this.model.tourStreamController.screenController.publishStreamId)
        return;
      if (item === this.model.tourStreamController.cameraController.publishStreamId)
        return;
      const video = document.getElementById("tourRemoteVideo-" + item);
      if (video != null && video.srcObject && !video.srcObject.active) {
        this.webRTCAdaptor.stop(item);
        // this.controller.removeRemoteVideo(item);
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
    });
  }
  removeRemoteVideo = (streamId) => {
    return;
    if (this.model.isMineTourStream(streamId)) {
      return;
    }
    const video = document.getElementById("tourRemoteVideo-" + streamId);
    if (video != null) {
      var player = document.getElementById("player-" + streamId);
      video.srcObject = null;
      document.getElementById("players").removeChild(player);
    }
    this.webRTCAdaptor.stop(streamId);
    this.streamsList = this.streamsList.filter(item => item !== streamId);
    this.model.dispatchEvent({ type: SCENE_INTERACTION.STREAM_REMOVED, data: { streamId } })
    const tourStarted = tourExists(tourID, this.model.tourData);
    if (!tourStarted) {
      return
    }
  }

  createRemoteVideo = (streamId) => {
    const player = document.createElement("div");
    player.className = "col-sm-3";
    player.id = "player" + streamId;
    player.innerHTML = '<video id="tourRemoteVideo' + streamId + '"controls autoplay playsinline></video>';
    document.getElementById("players").appendChild(player);
    // this.model.dispatchEvent({ type: SCENE_INTERACTION.STREAM_RECIEVED, data: { streamId } })
  }
  playVideo = (obj) => {
    if (this.model.isMineTourStream(obj.streamId)) {
      return;
    }
    return;


  }
  publish = (streamName, token) => {
    this.model.showLoading()
    this.publishing = true;
    this.webRTCAdaptor.publish(this.publishStreamId, token);
    // this.unmuteLocalMic();

    const videoTrack = $("#myTourVideoScreenshare");
    const data = {
      publishStreamId: this.publishStreamId
    };
    if (!videoTrack[0].srcObject) {
      videoTrack[0].addEventListener('loadeddata', () => {
        const videoTrack = $("#myTourVideoScreenshare");
        videoTrack[0].srcObject.getVideoTracks()[0].addEventListener('ended', () => {
          // console.log("User manually canceled screen sharing");
          this.model.tourOnScreenShareSeatStandUp();
          // this.muteLocalMic();
        });
      });
    } else {
      videoTrack[0].srcObject.getVideoTracks()[0].addEventListener('ended', () => {
        // console.log("User manually canceled screen sharing");
      });
    }
    // const stream = $("#tourVideo")[0].srcObject;
  }
  unPublish = (s) => {
    this.publishing = false;
    if (this.publishStreamId && this.webRTCAdaptor) {
      this.webRTCAdaptor.stop(this.publishStreamId);
    }
  }

  streamInformation = (obj) => {
    this.webRTCAdaptor.play(obj.streamId, this.token, this.roomNameBox);
  }
  joinRoom = () => {
    this.model.showLoading()
    this.roomJoined = true;
    this.publishStreamId = this.publishStreamId = `${"TOUR-SCREEN-SHARE" + this.model.config.userId}`;
    this.webRTCAdaptor.joinRoom(this.roomNameBox, this.publishStreamId);
  }


  switchVideo = (deviceId) => {
    if (!this.publishStreamId || !this.webRTCAdaptor) {
      return
    }
    this.webRTCAdaptor.switchVideoCameraCapture(this.publishStreamId, deviceId)
  }
  switchAudio = (deviceId) => {
    this.audioId = deviceId;
    if (!this.publishStreamId || !this.webRTCAdaptor) {
      return
    }
    this.webRTCAdaptor.switchAudioInputSource(this.publishStreamId, deviceId)
  }

  leaveRoom = () => {
    this.roomJoined = false;
    this.publishing = false;
    this.onConnectCallback = null;
    
    // Stop local video tracks
    const localVideo = document.getElementById("myTourVideoScreenshare");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }
    
    if (this.webRTCAdaptor) {
      this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
      this.webRTCAdaptor.closeStream();
    }
    // $('[id^="tourRemoteVideo"]').remove();
  }

  /**
   * Cleanup all tour screen share streams and wait for cleanup to complete
   * Returns a Promise that resolves when all streams are closed
   */
  cleanupStreams() {
    return new Promise((resolve) => {
      // If no adaptor exists, resolve immediately
      if (!this.webRTCAdaptor) {
        resolve();
        return;
      }

      // Stop local video tracks
      const localVideo = document.getElementById("myTourVideoScreenshare");
      if (localVideo && localVideo.srcObject) {
        localVideo.srcObject.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        localVideo.srcObject = null;
      }

      // Leave room and close stream
      if (this.webRTCAdaptor) {
        this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
        this.webRTCAdaptor.closeStream();
        
        // Wait a bit for cleanup to complete, then resolve
        setTimeout(() => {
          this.roomJoined = false;
          this.publishing = false;
          resolve();
        }, 300);
      } else {
        resolve();
      }
    });
  }

  muteLocalMic() {
    if (!this.webRTCAdaptor)
      return;
    this.isMicMuted = true;
    this.webRTCAdaptor.muteLocalMic();
    this.webRTCAdaptor.enableAudioLevelWhenMuted();
  }

  unmuteLocalMic() {
    if (!this.webRTCAdaptor)
      return;
    this.isMicMuted = false;
    this.webRTCAdaptor.unmuteLocalMic();
    this.webRTCAdaptor.disableAudioLevelWhenMuted();
  }
  turnOffLocalCamera() {
    this.isCameraOff = true;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.turnOffLocalCamera(this.publishStreamId);
  }

  turnOnLocalCamera() {
    this.isCameraOff = false;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.turnOnLocalCamera(this.publishStreamId);
  }

  switchLocalVideo(videoElement) {
    videoElement.srcObject = this.webRTCAdaptor.mediaManager.localStream;
    this.webRTCAdaptor.mediaManager.localVideo = videoElement;
  }
  switchLocalStream(mediaStream) {
    this.webRTCAdaptor.mediaManager.localStream = mediaStream;
  }

  findDominantSpeaker(streamSoundList) {
    let tmpMax = 0;
    let tmpStreamId = null;
    let threshold = 0.01;

    for (let i = 0; i < this.streamsList.length; i++) {
      let nextStreamId = this.streamsList[i];
      let tmpValue = streamSoundList[nextStreamId]
      if (tmpValue > threshold) {
        if (tmpValue > tmpMax) {
          tmpMax = tmpValue;
          tmpStreamId = nextStreamId;
        }
      }
    }
    if (tmpStreamId != null) {
      if (this.checkSpeakingStreamIds[tmpStreamId] == null || typeof this.checkSpeakingStreamIds[tmpStreamId] == "undefined") {
        // const icon = document.getElementById("audio" + tmpStreamId);
        // icon.style.visibility = "visible";
        this.checkSpeakingStreamIds[tmpStreamId] = true;
        setTimeout(() => {
          // const icon = document.getElementById("audio" + tmpStreamId);
          // icon.style.visibility = "hidden";
          this.checkSpeakingStreamIds[tmpStreamId] = null;
        }, 1000)
      }
    }
  }
}
